// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createDeliveryNoDocuments} from '../../shared/repositories';

export const createDeliveryNoDocumentsReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const deliveryNoDocumentsState = getState().reports.deliveryNoDocuments;

        const reportCriteria = {
            daysFromRegistration: deliveryNoDocumentsState.criteria.daysFromRegistration,
            dealers: deliveryNoDocumentsState.selectedDealers
        };

        try {

            const data = await createDeliveryNoDocuments(reportCriteria);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_DELIVERY_NO_DOCUMENTS_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/action-creators/create-report.js